// removed by extract-text-webpack-plugin
module.exports = {"whyUseInstaCredContainer":"whyUseInstaCredContainer__2tgRT","benefitsContainer":"benefitsContainer__23uxi","benefitContainer":"benefitContainer__1Ek01","benefitImg":"benefitImg__3GWFP","benefitContent":"benefitContent__3tNn8"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVB/whyCardlessEmi/style.css
// module id = Qd6Z
// module chunks = 446